import { NotificationSound } from 'shared/typings/notificationSettings/NotificationPayload'

import { RootState } from 'typesafe-actions'

const root = (state: RootState) => state.convo.notifications

export const getSoundNotificationSetting = (state: RootState) =>
  root(state).notificationSettings.sound

export const getIsNotificationSoundOn = (state: RootState) =>
  getSoundNotificationSetting(state) !== NotificationSound.NONE

export const getABMNotificationSetting = (state: RootState) => root(state).notificationSettings.ABM

export const getAllNotificationSettings = (state: RootState) =>
  state.convo.notifications.notificationSettings

export const getEmailNotificationSetting = (state: RootState) =>
  root(state).notificationSettings.email
